import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from './components/Layout'
import Dashboard from './pages/Dashboard'
import NewPlan from './pages/NewPlan'
import CalendarView from './pages/CalendarView'
import Simulator from './pages/Simulator'
import { useAuthStore } from './store/authStore'

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="new" element={<NewPlan />} />
        <Route path="calendar/:id" element={<CalendarView />} />
        <Route path="simulator" element={<Simulator />} />
        <Route path="simulator/:id" element={<Simulator />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App
